// Styles here will override Bulma styles
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import media, { setBreakPoints } from 'css-in-js-media';
import Element from '../../element';

setBreakPoints({ desktop: 1024 });

export const mainNav = css`
  box-shadow: rgba(3, 27, 78, 0.1) 0px 2px 4px;
  height: 65px;
  position: fixed;
  top: 41px;
  width: 100%;
  z-index: 20;

  ${media('<desktop')} {
    top: 0;
  }
`;

export const mainNavContainer = css`
  color: hsl(221, 93%, 16%) !important;
  margin-left: 50px;
  margin-top: 8px;
  padding: 0px;
  z-index: 20;
`;

export const PrimaryNavLink = styled(Element)`
  color: hsl(221, 93%, 16%) !important;
  background-color: transparent !important;
  font-family: 'WorkSans-Medium', 'Helvetica', 'san-serif';
  font-size: 14px !important;
  padding: 20px 12px;

  ${media('<desktop')} {
    font-size: 18px !important;
    margin-bottom: 10px;
    margin-left: 15px;
    margin-right: 15px;
    padding: 5px 0 15px 0;
  }
`;

export const primaryNavLinkBelowDesktop = styled.div`
  ${media('>= desktop')} {
  }
`;

export const DropdownButton = styled.div`
  display: flex;
  align-items: center !important;
  cursor: pointer;
  margin-right: 16px;

  .dropdown {
    margin-left: -7px;
  }

  &:hover {
    a {
      color: #0069ff !important;
    }
  }
`;

export const DropdownNavLink = styled.a`
  outline: none !important;
  background-color: transparent !important;
  color: hsl(221, 93%, 16%) !important;
  font-family: 'WorkSans-Medium', 'Helvetica', 'san-serif';
  font-size: 14px !important;
  padding-right: 25px;
  padding: 1.35rem 0.75rem;

  &.active {
    border-bottom: 2px solid rgb(0, 105, 255);
  }

  ${media('<desktop')} {
    font-size: 18px !important;
    margin-bottom: 10px;
    margin-left: 15px;
    margin-right: 15px;
    padding: 5px 0 15px 0;
    margin-bottom: -60px;

    width: 100%;
    border-bottom: 1px solid hsl(218, 18%, 91%) !important;

    &.active {
      border-bottom: none;
    }
  }
`;
